/**
 * Special ❄️ WK Wrapper for sending PostMessage into WKWebview
 * Used to communicate to the native host app.
 *
 * NAMESPACE must match what's defined in the host app.
 *
 * Note that there are 2 files like this:
 * - app/resources/public/js/splash/utils/wkwebview-postmessage.js
 * - app/frontend/standalone/splash-page/mobile-rsvp/wkwebview-postmessage.js
 */

const NAMESPACE = 'hostapp';

/**
 * wkPostMessage
 * @link   http://www.priyaontech.com/2014/12/native-%E2%80%93-js-bridging-on-ios8-using-wkwebview
 * @param  {string} action Host app subscribes to actions, e.g. 'submit'
 * @param  {object} data
 * @return void
 */
export default function wkPostMessage(actionParam, dataParam) {
    const action = actionParam || 'unknown';
    const data = dataParam || {};

    // iOS
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[NAMESPACE]) {
        window.webkit.messageHandlers[NAMESPACE].postMessage({
            action,
            data,
        });
        // Android
    } else if (window[NAMESPACE]) {
        // Older Android versions only support passing primitive
        // types (Int, String, etc.), so the payload needs to be String
        window[NAMESPACE].postMessage(
            JSON.stringify({
                action,
                data,
            }),
        );
    }
}
